define(['moduler'], function (Moduler) {
    'use strict';

    /*
        Example HTML:

        <div class="Tabs" data-module="tabs">
            <ul class="Tabs-list">
                <li class="Tabs-item" data-name="tab-one">Tab One</li>
                <li class="Tabs-item" data-name="tab-two">Tab Two</li>
            </ul>

            <div class="Tabs-panels">
                <div class="Tabs-panel">
                    <!-- panel 1 -->
                </div>

                <div class="Tabs-panel">
                    <!-- panel 2 -->
                </div>
            </div>
        </div>
    */

    return Moduler.create({
        defaults: {
            event: 'click',
            handles: '.Tabs-item',
            panels: '.Tabs-panel',
            activeClass: 'is-active',
            togglable: false, // whether to allow a panel to close if you click on its handle again.
            scrollable: false, // whether to activate horizontal scroll if needed
            showFirst: true, // whether to show first (or selected) panel on load.
            selectedPanel: null, // the panel to show at page load (optional).
            defaultTab: 0,
            tabParam: 'tab',
            tabChangeHandler: null // add a function here to have it called when the user changes tab
        },

        init: function () {
            var self = this;
            
            self.bindEvents(self);

            self.handles = Array.from(self.el.querySelectorAll(self.options.handles));

            self.panels = Array.from(self.el.querySelectorAll(self.options.panels));
            
            self.handles.forEach(handle => {
                handle.addEventListener(self.options.event, function (e) {
                    e.data = self;
                    self.showPanel(e);
                });
                handle.addEventListener('keydown', e => {
                    if (e.key === 'Enter') {
                        e.target.dispatchEvent(new Event('click'));
                        e.data = self;
                        self.showPanel(e);
                    }
                });
            });


            if (self.options.selectedPanel) {
                let selectedHandle = self.handles.filter(el => el.matches('[data-name="' + self.options.selectedPanel + '"]'))[0];
                if (selectedHandle) {
                    selectedHandle.dispatchEvent(new Event(self.options.event));
                }
            } else if (self.options.showFirst) {
                let selectedTab = self.options.defaultTab;
                var params = window.location.search.split("?")[1];
                if (params) {
                    var paramsArr = params.split("&");
                    for (var i = paramsArr.length - 1; i >= 0; i -= 1) {
                        var parts = paramsArr[i].split("=");
                        if (parts[0] === self.options.tabParam && parts[1] > 0 && self.handles.length > parts[1]) {
                            selectedTab = parts[1];
                        }
                    }
                }

                if (!selectedTab) {
                    selectedTab = 0;
                }

                Array.from(self.handles)[selectedTab].dispatchEvent(new Event(self.options.event));
            }

            if (self.options.scrollable) {
                self.centerSelected(self);
                self.toggleNavigationButtons(self);
            }
        },

        bindEvents: function (self) {
            if (self.options.scrollable) {
                self.el.querySelector('.js-tabsLeft')?.addEventListener('click', function (event) {
                    event.preventDefault();
                    self.scrollNavigation(self, 'left');
                });

                self.el.querySelector('.js-tabsRight')?.addEventListener('click', function (event) {
                    event.preventDefault();
                    self.scrollNavigation(self, 'right');
                });

                self.el.querySelectorAll('.js-tabsScrollable').forEach(tab => {
                    tab.addEventListener('scroll', function () {
                        self.toggleNavigationButtons(self);
                    });
                });

                // Timeout so the event run only once
                var resizeTimeout;
                window.onresize = function (event) {
                    clearTimeout(resizeTimeout);

                    resizeTimeout = setTimeout(function () {
                        self.toggleNavigationButtons(self);
                        self.centerSelected(self);
                    }, 500);
                };
            }
        },

        showPanel: function (e) {
            e.preventDefault();

            let self = e.data;
            let handle = e.target;
            let handleIndex = self.handles.indexOf(handle);

            // if event was triggered on a link inside "handles" then we try to find the handle element now
            if (!handle.matches(self.options.handles)) {
                handle = handle.closest(self.options.handles);
                handleIndex = self.handles.indexOf(handle);
            }

            let panel = self.panels[handleIndex];

            self.handles.filter(h => h !== handle).forEach(h => {
                h.classList.remove(self.options.activeClass);
                h.dispatchEvent(new CustomEvent('Tab-hide'));
            });

            self.panels.filter(p => p !== panel).forEach(p => {
                p.classList.remove(self.options.activeClass);
                p.dispatchEvent(new CustomEvent('Tab-hide'));
            });

            if (self.options.togglable) {
                handle.classList.toggle(self.options.activeClass);
                panel.classList.toggle(self.options.activeClass);
            } else {
                handle.classList.add(self.options.activeClass);
                panel.classList.add(self.options.activeClass);
            }
            handle.dispatchEvent(new CustomEvent('Tab-show'));
            panel.dispatchEvent(new CustomEvent('Tab-show'));

            if (self.options.tabChangeHandler != null) {
                self.options.tabChangeHandler.call(panel);
            }

            var params = window.location.search.split("?")[1];
            var tabP = '';
            if (handleIndex > 0) {
                tabP = self.options.tabParam + "=" + handleIndex;
            }
            if (!params) {
                params = tabP;
            } else {
                var paramsArr = params.split("&");
                for (var i = paramsArr.length - 1; i >= 0; i -= 1) {
                    var parts = paramsArr[i].split("=");
                    if (parts[0] === self.options.tabParam) {
                        paramsArr.splice(i, 1);
                    }
                }
                if (tabP.length > 0) {
                    paramsArr.push(tabP);
                }
                params = paramsArr.join("&");
            }

            var query = params != null && params.length > 0 ? '?' + params : '';
            if (query.startsWith('#')) {
                window.history.pushState(null, null, location.pathname + query);
            } else if (query.length == 0) {
                window.history.pushState(null, null, location.pathname);
            } else {
                window.history.pushState(null, null, query);
            }

            if (self.options.scrollable) {
                self.centerSelected(self);
            }
        },

        scrollNavigation: function (self, direction) {
            var scrollable = self.el.querySelector('.js-tabsScrollable');

            let scrollAmount = scrollable.getBoundingClientRect().width/2;
            if (direction !== 'right') {
                scrollAmount = -scrollAmount;
            }
            scrollable.scrollBy({ left: scrollAmount, top: 0, behavior: 'smooth' });
        },

        toggleNavigationButtons: function (self) {
            let scrollable = self.el.querySelector('.js-tabsScrollable');
            let scrollableWidth = scrollable.getBoundingClientRect().width;
            let tabsItemsWidth = self.el.querySelector('.js-tabsItems').getBoundingClientRect().width;
            let scrollLeft = scrollable.scrollLeft;
            let leftButton = self.el.querySelector('.js-tabsLeft');
            let rightButton = self.el.querySelector('.js-tabsRight');

            if (tabsItemsWidth > scrollableWidth) {
                if (leftButton) {
                    if (scrollLeft > 0) {
                        leftButton.classList.remove("hide200");
                        leftButton.classList.add("show200");
                    } else {
                        leftButton.classList.remove("show200");
                        leftButton.classList.add("hide200");
                    }
                }

                if (rightButton) {
                    if (scrollLeft + scrollableWidth < tabsItemsWidth - 2) {
                        rightButton.classList.remove("hide200");
                        rightButton.classList.add("show200");
                    } else {
                        rightButton.classList.remove("show200");
                        rightButton.classList.add("hide200");
                    }
                }
            } else {
                leftButton?.classList.remove("show200");
                leftButton?.classList.add("hide200");
                rightButton?.classList.remove("show200");
                rightButton?.classList.add("hide200");
            }
        },

        centerSelected: function (self) {
            let scrollable = self.el.querySelector('.js-tabsScrollable'),
                selected = self.el.querySelector('.is-active'),
                selectedWidth = selected.getBoundingClientRect().width,
                selectedPosition,
                newScrollPosition,
                lastKnownScrollPosition = scrollable.scrollLeft;
                
            // Reset scroll to get correct offset of selected item
            scrollable.scrollLeft = 0;
            
            selectedPosition = (selected ? selected.getBoundingClientRect().left : 0) + selectedWidth;

            //// Restore scroll position so animation can be done
            scrollable.scrollLeft = lastKnownScrollPosition;
            newScrollPosition = selectedPosition - (window.innerWidth / 2) - (selectedWidth / 2);
            newScrollPosition = (newScrollPosition > 0 ? newScrollPosition : 0);

            scrollable.scrollBy({ left: newScrollPosition - scrollable.scrollLeft, top: 0, behavior: 'smooth' });
        }
    });
});